//Packages
import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
//Material UI Components
import {
  Grid,
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Stack,
} from "@mui/material";
//API Route
import { Route } from "../../utils/config";
//Context
import { userContext } from "../../Context";
import MapContainer from "../../components/MapContainer";

export default function NewProject() {
  //User context
  const { user } = useContext(userContext);
  //History from router, used to redirect user back to projects page.
  const history = useHistory();

  const [isLoaded, setIsLoaded] = useState(false);

  //Dropdown values to be loaded from system
  const [dropdowns, setDropdowns] = useState({
    types: [],
    subTypes: [],
    statuses: [],
    qualities: [],
  });

  //Form state
  const [form, setForm] = useState({
    id: -1,
    primaryPartnerId: user.partnerId,
    name: "",
    projectTypeId: 100,
    projectSubTypeId: 0,
    address: "",
    radius: 0,
    country: "",
    tags: "",
    region: "",
    postalCode: "",
    benifactorCount: 0,
    yearBuilt: 0,
    builtBy: "",
    latitude: 0,
    longitude: 0,
    projectQualityId: 0,
    projectStatusId: 0,
    overview: "",
    isApproved: false,
    isDeleted: false,
  });

  useEffect(() => {
    getDropdownValues();
  }, []);

  //Gets dropdown value data from system
  const getDropdownValues = () => {
    axios
      .get(`${Route}/Application/GetSystemData`)
      .then((res) => {
        setDropdowns({
          types: res.data.projectTypeList,
          subTypes: res.data.projectSubTypeList,
          statuses: res.data.projectStatusList,
          qualities: res.data.projectQualityList,
        });
        setIsLoaded(true);
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleInputChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    let store = JSON.parse(localStorage.getItem("login"));
    axios
      .post(`${Route}/Projects/RequestNewProject`, JSON.stringify(form), {
        headers: {
          Authorization: `Bearer ${store.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        history.push("/profile/projects");
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <Grid container item xs={11}>
      {isLoaded ? (
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Grid container item justifyContent="center" mt={2}>
            <Grid item xs={12} mb={2}>
              <Typography variant="h5">Create a New Project</Typography>
            </Grid>
            <Grid container item spacing={4}>
              <Grid container item xs={12} md={8} spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    required
                    label="Project Name"
                    name="name"
                    value={form.name}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Project #"
                    name="projectId"
                    value={form.projcetId}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="type">Project Type</InputLabel>
                    <Select
                      labelId="type"
                      label="Project Type"
                      value={form.projectTypeId || 0}
                      name="projectTypeId"
                      onChange={(e) => {
                        setForm({
                          ...form,
                          projectTypeId: e.target.value,
                          projectSubTypeId: dropdowns.subTypes.filter(
                            (subtype) => subtype.parentId === e.target.value
                          )[0].id,
                        });
                      }}
                    >
                      {dropdowns.types.map((type) => {
                        return (
                          <MenuItem key={type.id} value={type.id}>
                            {type.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="subtype">Project Sub Category</InputLabel>
                    <Select
                      labelId="subtype"
                      label="Project Subtype"
                      value={form.projectSubTypeId || 0}
                      name="projectSubTypeId"
                      onChange={handleInputChange}
                    >
                      <MenuItem value={0}>No Subtype</MenuItem>

                      {dropdowns.subTypes
                        .filter(
                          (subtype) => subtype.parentId === form.projectTypeId
                        )
                        .map((subtype) => {
                          return (
                            <MenuItem key={subtype.id} value={subtype.id}>
                              {subtype.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    required
                    label="Address"
                    name="address"
                    value={form.address}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Location Radius (in miles)"
                    name="radius"
                    value={form.radius}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Coordinates"
                    name="coordinates"
                    value={form.coordinates}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Latitude"
                    name="latitude"
                    value={form.latitude}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Longitude"
                    name="longitude"
                    value={form.longitude}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    required
                    label="Country"
                    name="country"
                    value={form.country}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    required
                    label="Region"
                    name="region"
                    value={form.region}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    required
                    fullWidth
                    label="Postal Code"
                    name="postalCode"
                    value={form.postalCode}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Number of Beneficients"
                    name="benifactorCount"
                    value={form.benifactorCount}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Year Built"
                    name="yearBuilt"
                    value={form.yearBuilt}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Built by"
                    name="builtBy"
                    value={form.builtBy}
                    onChange={handleInputChange}
                  />
                </Grid>
                {/* <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="quality">Quality of Project</InputLabel>
                    <Select
                      labelId="quality"
                      label="Project Quality"
                      defaultValue={form.projectQualityId || 0}
                      value={form.projectQualityId || 0}
                      name="projectQualityId"
                      onChange={handleInputChange}
                    >
                      <MenuItem value={0}>None</MenuItem>

                      {dropdowns.qualities.map((quality) => {
                        return (
                          <MenuItem key={quality.id} value={quality.id}>
                            {quality.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid> */}
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="status">Project Status</InputLabel>
                    <Select
                      label="Project Status"
                      labelId="status"
                      defaultValue={form.projectStatusId || 0}
                      value={form.projectStatusId}
                      name="projectStatusId"
                      onChange={handleInputChange}
                    >
                      <MenuItem value={0}>None</MenuItem>

                      {dropdowns.statuses.map((status) => {
                        return (
                          <MenuItem key={status.id} alue={status.id}>
                            {status.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth></FormControl>
                </Grid>
                <Grid item xs={12} pb={4}>
                  <Button variant="contained" size="large" type="submit">
                    Request Project
                  </Button>
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                md={4}
                spacing={2}
                columnSpacing={2}
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Stack width="100%" py={2}>
                  <TextField
                    fullWidth
                    label="Project Overview"
                    name="overview"
                    value={form.overview}
                    onChange={handleInputChange}
                    multiline
                    maxRows={6}
                    minRows={6}
                  />
                </Stack>
                <Stack
                  width="100%"
                  height="293px"
                  style={{ borderRadius: "35px", overflow: "hidden" }}
                >
                  <MapContainer
                    locations={[{ lat: form.latitude, lng: form.longitude }]}
                    radius={form.radius}
                    zoomLevel={1}
                    disableHover
                  ></MapContainer>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <></>
      )}
    </Grid>
  );
}
